// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { Action } from "redux"
import { DeleteFavouriteTagRequest } from "generated/legebill/site/tag/v4/tag_pb"
import * as Actions from "../actions"
import { grpc } from "app/rpc/executor"
import { tagServiceClient } from "app/rpc/client"
import { Empty } from "google-protobuf/google/protobuf/empty_pb"
import { isGrpcError } from "../../../lib/rpcutils"
import { StatusCode } from "grpc-web"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type DeleteFavouriteTagRpc = (request: DeleteFavouriteTagRequest) => Observable<Empty>

export const deleteFavouriteTag = (deleteFavouriteTagRpc: DeleteFavouriteTagRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.deleteFavouriteTag.match),
      mergeMap(({ payload: { request, siteId, }}) =>
        of(request)
          .pipe(
            mergeMap(deleteFavouriteTagRpc),
            map(_ => Actions.fetchFavouriteTags({ siteId })),
            catchError(handleError),
          )),
    )

const deleteFavouriteTagRpc = (request: DeleteFavouriteTagRequest): Observable<Empty> =>
  grpc(() => tagServiceClient.deleteFavouriteTag(request, null))

const handleError = (e: unknown): Observable<Action> => {
  if (isGrpcError(e)) {
    const { code } = e
    if (code === StatusCode.PERMISSION_DENIED) {
      return of(showSnackBar({
        message: t({ id: "msg_unfavourite_tag_permission_denied", message: "Failed to unfavourite tag. You do not have permission to access this tag." }),
        messageType: "ERROR",
      }))
    }
  }

  return of(showSnackBar({
    message: t({ id: "msg_unfavourite_tag_failed", message: "Failed to unfavourite tag. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
    messageType: "ERROR",
  }))
}

export default deleteFavouriteTag(deleteFavouriteTagRpc)
